import SessionEventProto from "../session-event-proto";
import {BUS_COMPANY_USERS_CHANGED} from "../../model2/company-user-new/@const";


// const debug = "EventCompanyUserChange";
const debug = false;


export default class EventCompanyUserChange extends SessionEventProto {

    process() {
        if (this.isDifferentCompany()) return false;

        if (!!debug) {
            console.groupCollapsed("event {EventUserChange}");
            console.log("companyId",this.data.companyId);
            console.log("userId",this.data.userId);
            console.log("companyRole",this.data.companyRole);
            console.log("departmentId",this.data.departmentId);
            //console.groupEnd();
        }

        const id = this.data.companyId+"-"+this.data.userId;
        const companyUser = gd.session.companyUsers.get(id);

        if (!companyUser) return

        companyUser.companyRole        = this.data.companyRole
        companyUser.departmentId       = this.data.departmentId
        companyUser.workWeek           = this.data.workWeek

        companyUser.updateWorkdayDurations(this.data.workdayDurations);

        gd.bus.triggerEvent(BUS_COMPANY_USERS_CHANGED)

        if (!!debug) {
            console.log("Session user = ",companyUser);
            console.groupEnd();
        }


    }
};

// var EventCompanyUserChange = function(uid,data) {
//     this.data = data;
//     this.uid = uid;
// };
//
// EventCompanyUserChange.prototype.validate = function(){
//     return true;
// };
//
// EventCompanyUserChange.prototype.process = function(){
//
//     if (debug) {
//         console.groupCollapsed("event {EventUserChange}");
//         console.log("companyId",this.data.companyId);
//         console.log("userId",this.data.userId);
//         console.log("companyRole",this.data.companyRole);
//         console.log("departmentId",this.data.departmentId);
//         //console.groupEnd();
//     }
//
//     var id = this.data.companyId+"-"+this.data.userId;
//     var user = gd.session.companyUsers.get(id);
//
//     user.set({
//         companyRole: this.data.companyRole,
//         departmentId: this.data.departmentId,
//         workWeek: this.data.workWeek,
//         // workdayDurations: this.data.workdayDurations - see methond below
//     },{silent:false});
//
//     user.updateWorkdayDurations(this.data.workdayDurations);
//
//     if (debug) {
//         console.log("Session user = ",user);
//         console.groupEnd();
//     }
// };
//
//
// module.exports = EventCompanyUserChange;